import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightToBracket, faRemove } from "@fortawesome/free-solid-svg-icons";
import LogIn from "../Images/login.svg";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { sha256 } from "js-sha256";
import { levenshteinDistance, passwordToEmojiSeed } from "./encrypt";
import { DateTime } from "luxon";

function HomePage() {
  const [input, setInput] = useState("");
  const [mode, setMode] = useState(true);
  const [start, setStart] = useState(0);

  const checkInput = () => {
    let timeDifference =
      DateTime.now().diff(start, "seconds").values.seconds + "s";
    let setPassword = localStorage.getItem("key");
    let plaintext = localStorage.getItem("pkey");
    let dist = levenshteinDistance(String(input), String(plaintext));
    let accuracy = (dist / String(plaintext).length) * 100;
    if (!mode) {
      if (plaintext && plaintext === input) {
        Swal.fire({
          title: "Success",
          html: `<p>Successful log in</p><p>${timeDifference}</p>`,
          icon: "success",
          confirmButtonText: "Dismiss",
        });
        setInput("");
      } else if (plaintext && plaintext !== input) {
        Swal.fire({
          title: "Error",
          html: `<p>Incorrect Password</p><p></p>Error rate ${accuracy}%<p>Input Accuracy ${dist}</p> <p>${
            timeDifference || "0 sec"
          }</p>`,
          icon: "error",
          confirmButtonText: "Dismiss",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: `Password not set`,
          icon: "error",
          confirmButtonText: "Dismiss",
        });
      }
    } else if (setPassword && setPassword === sha256(input)) {
      Swal.fire({
        title: "Success",
        html: `<p>Successful log in</p><p>${timeDifference}</p>`,
        icon: "success",
        confirmButtonText: "Dismiss",
      });
      setInput("");
    } else if (setPassword && setPassword !== sha256(input)) {
      Swal.fire({
        title: "Error",
        html: `<p>Incorrect Password</p><p></p>Error rate ${accuracy}%<p>Input Accuracy ${dist}</p> <p>${
          timeDifference || "0 sec"
        }</p>`,
        icon: "error",
        confirmButtonText: "Dismiss",
      });
    } else {
      Swal.fire({
        title: "Error",
        text: `Password not set`,
        icon: "error",
        confirmButtonText: "Dismiss",
      });
    }
  };
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-6">
          <div className="card text-center">
            <div className="card-body">
              <p className="card-title display-6 gray">Log In</p>
              <div className="img">
                <img
                  src={LogIn}
                  width="260"
                  height="230"
                  className=""
                  alt="login"
                />
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  checkInput();
                }}
              >
                <div className={mode ? "input-group mb-3" : "d-none"}>
                  <input
                    className="form-control text-center"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={input?.length ? passwordToEmojiSeed(input) : ""}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace") setInput("");
                    }}
                    autoComplete={false}
                    onChange={(e) =>
                      setInput((input) => input + e.nativeEvent.data)
                    } //e.nativeEvent.data
                    onFocus={() => {
                      setStart(DateTime.now());
                    }}
                  />
                  <button
                    onClick={() => setInput("")}
                    className="btn btn-outline-danger"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faRemove} size="1x" />
                  </button>
                </div>
                <div className={!mode ? "input-group mb-3" : "d-none"}>
                  <input
                    className="form-control text-center"
                    id="passwordp"
                    name="passwordp"
                    autoComplete={false}
                    placeholder="Password"
                    type="password"
                    value={input}
                    onChange={(e) => setInput(e.target.value)} //e.nativeEvent.data
                    onFocus={() => {
                      setStart(DateTime.now());
                    }}
                  />
                  <button
                    onClick={() => setInput("")}
                    className="btn btn-outline-danger"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faRemove} size="1x" />
                  </button>
                </div>
                <div className="d-grid gap-2">
                  <button type="submit" className="bttn">
                    <FontAwesomeIcon icon={faRightToBracket} /> Log In
                  </button>
                </div>
              </form>
            </div>
            <div className="toggle">
              <p
                className="text-success"
                onClick={() => {
                  setMode(!mode);
                  setInput("");
                }}
              >
                {!mode ? "Asterisk mode" : "Emoji Mode"}
              </p>
            </div>
            <div className="card-footer text-muted link">
              Not registered? <Link to="/register">Sign Up</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
